import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { initWebVitalsTracking } from "./perf/webVitals.js";
import * as Sentry from "@sentry/browser";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN || "";
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_APP_ENV || "development",
    release: import.meta.env.VITE_APP_VERSION || "local",
    tracesSampleRate: 0.1,
  });
}
initWebVitalsTracking();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

